module.exports = __webpack_public_path__ + "img/IC_Msg_Error.412190f8.svg";